import React from 'react'
import { TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { Text, color } from '@trivie/ui-mobile'

import aha_logo from '../aha_logo.png'

export interface SubscriptionsTabProps {
  searchTerm?: string
}

export const SubscriptionsTab = observer((props: SubscriptionsTabProps) => {
  const { libraryStore } = useStores()
  const { contentPacks } = libraryStore
  const { searchTerm } = props

  const history = useHistory()

  const goToPack = (pack: any) => {
    history.push(
      `/library/subscription/?subscription_id=${pack.contentpack_id}&expired=${
        pack.expired ?? false
      }`,
    )
  }

  const filtered = (contentPacks ?? []).filter(
    (pack: any) =>
      !searchTerm || pack.title?.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
  )

  return (
    <div style={CONTENT}>
      <div style={PACK_GRID}>
        {filtered.map((pack: any) => (
          <TouchableOpacity
            key={`aha-pack-${pack.contentpack_id}`}
            accessibilityRole="button"
            accessibilityLabel={`Open ${pack.title}`}
            onPress={() => goToPack(pack)}
            style={{ ...PACK_CARD, backgroundColor: pack?.color }}
          >
            <View style={PACK_CONTAINER}>
              <img height={28} width={22} src={aha_logo} alt="aha logo" />
              {['BLS', 'PALS', 'ACLS'].includes(pack.title) ? (
                <Text
                  text="For Healthcare Professionals"
                  style={{ width: 98, color: '#fff', textAlign: 'right' }}
                  variant="body1Emphasized"
                />
              ) : null}
            </View>
            <View style={{ flexDirection: 'column' }}>
              <Text text={pack.title} style={PACK_NAME} variant="titleEmphasized" />
              <Text
                tx="Topic.topicCount"
                txOptions={{ count: pack.topic_count }}
                variant="body1Medium"
                style={PACK_SUBTITLE}
              />
            </View>
          </TouchableOpacity>
        ))}
      </div>
    </div>
  )
})

const CONTENT: React.CSSProperties = {
  backgroundColor: color.white,
  height: '100%',
}
const PACK_GRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(188px, 1fr))',
  gridGap: 16,
  gridAutoRows: 'minmax(80, auto)',
  paddingTop: 0,
  paddingBottom: 20,
}
const PACK_CARD: ViewStyle = {
  height: 155,
  borderRadius: 21.67,
  paddingVertical: 14,
  paddingHorizontal: 12,
  flexDirection: 'column',
  justifyContent: 'space-between',
}
const PACK_NAME: TextStyle = { lineHeight: 20, color: color.white }
const PACK_SUBTITLE: TextStyle = { lineHeight: 16.94, color: 'rgba(255,255,255,0.8)' }
const PACK_CONTAINER: ViewStyle = { flex: 1, flexDirection: 'row', justifyContent: 'space-between' }
